import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1abebbf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark nav-custom" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Topo Fire")
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Topo Maps+")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_8 = {
  id: "navbarSupportedContent",
  class: "collapse navbar-collapse"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "navbar-nav me-auto mb-2 mb-lg-0" }, null, -1))
const _hoisted_10 = { class: "navbar-nav" }
const _hoisted_11 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Plans")
const _hoisted_13 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Teams")
const _hoisted_15 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("IRPG")
const _hoisted_17 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Pricing")
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Help")
const _hoisted_21 = { class: "nav-item dropdown" }
const _hoisted_22 = {
  id: "navbarDropdown",
  class: "nav-link dropdown-toggle",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_23 = { class: "d-inline-flex flex-row" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  class: "dropdown-menu",
  "aria-labelledby": "navbarDropdown"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Settings")
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Admin")
const _hoisted_30 = { key: 2 }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Log Out")
const _hoisted_32 = { key: 3 }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Log In")
const _hoisted_34 = {
  key: 4,
  class: "nav-item contact-button-li"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "mailto:support@topofire.com",
  class: "contact-button contact-button-fire"
}, " Book a Demo", -1))
const _hoisted_36 = [
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CircleImage = _resolveComponent("CircleImage")!

  return _withDirectives((_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isTopoFire)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "navbar-brand nv-brand",
            to: "/"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "logo-image",
                src: require('@/assets/images/img/TopoFire-60-Rounded@3x.png'),
                alt: "Logo Image"
              }, null, 8, _hoisted_3),
              _hoisted_4
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            class: "navbar-brand nv-brand",
            to: "/"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "logo-image",
                src: require('@/assets/images/img/Icon-60-Rounded@3x.png'),
                alt: "Logo Image"
              }, null, 8, _hoisted_5),
              _hoisted_6
            ]),
            _: 1
          })),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("ul", _hoisted_10, [
          (!_ctx.isTopoFire)
            ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/plans"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isTopoFire)
            ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/teams"
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isTopoFire)
            ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/nwcg-incident-response-pocket-guide"
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isTopoFire)
            ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/pricing"
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_19, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/help"
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_21, [
            _createElementVNode("a", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                (_ctx.shouldShowAvatar)
                  ? (_openBlock(), _createBlock(_component_CircleImage, {
                      key: 0,
                      imgurl: _ctx.usrImgURL,
                      size: 30
                    }, null, 8, ["imgurl"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_24, "Account"))
              ])
            ]),
            _createElementVNode("ul", _hoisted_25, [
              (_ctx.status.loggedIn)
                ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                    _createVNode(_component_router_link, {
                      class: "dropdown-item",
                      to: "/settings#account"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isAdmin)
                ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                    _createVNode(_component_router_link, {
                      class: "dropdown-item",
                      to: "/admin"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_29
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.status.loggedIn)
                ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                    _createVNode(_component_router_link, {
                      class: "dropdown-item",
                      to: "/logout"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_31
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("li", _hoisted_32, [
                    _createVNode(_component_router_link, {
                      class: "dropdown-item",
                      to: "/login"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_33
                      ]),
                      _: 1
                    })
                  ]))
            ])
          ]),
          (_ctx.isTopoFire)
            ? (_openBlock(), _createElementBlock("li", _hoisted_34, _hoisted_36))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.showGlobalHeader]
  ])
}